var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c(_vm.component,_vm._b({tag:"component",attrs:{"value":true},on:{"close":_vm.dismissDialog}},'component',_vm.props,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }